// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://pxgcyjkwwkkmvaxnhale.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InB4Z2N5amt3d2trbXZheG5oYWxlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTc3MDY3OTcsImV4cCI6MjA3MzI4Mjc5N30.u7LUT-LAiRfx9N3ihembPEvSWLngc_VqWdQZA_PNN0M";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});